import { Link } from "react-router-dom";
import Input from "../../../components/input/input";
import Label from "../../../components/label/label";

function ObTax({ onNext, onBack, formData, onUpdateData }) {
    const handleNextClick = () => {
        const data = { additionalData: "Weitere Daten abgeschlossen" };
        onNext(data);
    };

    const handleBackClick = () => {
        onBack();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onUpdateData({ [name]: value });
    };

    return (
        <div>
            <h2>Und zu guter Letzt, die Infos zu Steuern.</h2>
            <Label labelFor="taxOffice" labelValue="Finanzamt: " /><br/>
            <Input
                inputType="text"
                inputName="taxOffice"
                inputValue={formData.taxOffice || ''}
                onChange={handleInputChange}
                borderColor="black"
            /><br />
            <Label labelFor="taxNumber" labelValue="Steuernummer: " /><br/>
            <Input
                inputType="text"
                inputName="taxNumber"
                inputValue={formData.taxNumber || ''}
                onChange={handleInputChange}
                borderColor="black"
            />
            <div className="linkContainer">
                <Link onClick={handleBackClick}>Zurück</Link>
                <Link onClick={handleNextClick}>Abschließen</Link>
            </div>
        </div>
    );
}

export default ObTax;